import React from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../../public/styles/HomeInteriors/RecentWorksPage/GlimpseInto.scss"

function GlimpseInto(props) {

  const {
    title,
    videoLinks,
  } = props;

  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: false,
    nextArrow: false,
    autoplay: false /* this is the new line */,
    autoplaySpeed: 5000,
    arrows: false,
  };


  return (
    <div className="glimpse-into">
      <div className="title">{title}</div>
      <div className="video-slider">
        <Slider {...settings} >
          {!!videoLinks &&
                    videoLinks.map((videolink, index) => 
                      (
                        (
                       
                          <iframe width="520" height="420" src={videolink.link} title={videolink.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            
                        )
                      )
                    )
          }
        </Slider>
      </div>
    </div>
  )
}

export default GlimpseInto